import useMediaQueryGetter, {MediaQuery} from './useMediaQueryGetter';

/** @deprecated Use `breakpoints` from `useAppTheme` hook */
export default function useMediaQuery(query: MediaQuery): string {
  const getter = useMediaQueryGetter();
  return getter(query);
}